import closeIcon from 'assets/img/close-icon-black.svg'
import {mockNotifications} from 'utils/mockData'

const NotificationsSidebar = ({isOpen, onClose}) => {
  if (!isOpen) return null

  return (
    <div className="fixed mt-20 lg:mt-0 lg:ml-[212px] inset-0 bg-black bg-opacity-50 z-50">
      <div className="absolute top-0 h-full bg-white shadow-lg w-full max-w-full lg:w-[400px]">
        <h2 className="text-[20px] font-semibold mb-4 text-[#0A0A0A] mx-6 text-left mt-8 pb-4 border-b">
          Notifications
        </h2>
        <img
          src={closeIcon}
          alt="close"
          className="absolute right-6 top-8 cursor-pointer"
          onClick={onClose}
        />
        <div className="px-6">
          {mockNotifications?.map((notification, i) => (
            <div
              key={i}
              className={`cursor-pointer flex items-center gap-x-4 py-3 px-1 mt-6 ${notification?.isRead ? 'bg-white' : 'bg-[#F4F7FB]'}`}
            >
              <img
                src={notification?.image}
                alt="notification"
                className="flex-shrink-0 w-10 h-10"
              ></img>
              <div className="flex flex-col">
                <p className="text-[#0A0A0A] font-semibold text-sm">
                  {notification?.title}
                </p>
                <p className="text-[#0A0A0A] mt-2">{notification?.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default NotificationsSidebar
